import { InvitationInfoData } from "../../models/invitationsApiTypes"

interface AnteprimaSectionProps {
  previewInvitation: InvitationInfoData | null
  previewMessage: string
}

export default function AnteprimaSection({
  previewInvitation,
  previewMessage,
}: AnteprimaSectionProps) {
  return (
    <div className="preview-section">
      <div className="form-label">Anteprima</div>
      <div className="preview-card">
        {previewInvitation ? (
          <>
            <div className="preview-meta">
              Esempio su: {previewInvitation.name} ({previewInvitation.reservationCode})
            </div>
            <div className="preview-content">{previewMessage}</div>
          </>
        ) : (
          <div className="preview-empty">Nessun invito disponibile per anteprima.</div>
        )}
      </div>
    </div>
  )
}
